/// <reference path="./bezier.d.ts" />
import { PdfPoint, PdfVector } from '../pdf';
import { GUtil } from '../gutil';
import { PageGen, PdfSize, PdfUnit } from '../pdf';
import { PdfPen, PdfBrush, PdfRect } from '../pdf';

export class BezierCurve {
  public segments: BezierSegment[] = [];

  constructor(public startPoint: PdfPoint = PdfPoint.zero) {}

  public addLine(p: PdfPoint): void {
    const p0 =
      this.segments.length === 0 ? this.startPoint : this.segments[this.segments.length - 1].P1;
    this.segments.push(new BezierSegment(p0, PdfVector.zero, p, PdfVector.zero));
  }

  public addSegment(v0: PdfVector, p1: PdfPoint, v1: PdfVector): void {
    const p0 =
      this.segments.length === 0 ? this.startPoint : this.segments[this.segments.length - 1].P1;
    this.segments.push(new BezierSegment(p0, v0, p1, v1));
  }

  public addSymmetrical(p1: PdfPoint, v1: PdfVector): void {
    const p0 =
      this.segments.length === 0 ? this.startPoint : this.segments[this.segments.length - 1].P1;
    const v0 =
      this.segments.length === 0
        ? PdfVector.zero
        : new PdfVector(
            -this.segments[this.segments.length - 1].V1.dx,
            -this.segments[this.segments.length - 1].V1.dy
          );
    this.segments.push(new BezierSegment(p0, v0, p1, v1));
  }
}

export class BezierSegment {
  constructor(
    public readonly P0: PdfPoint,
    public readonly V0: PdfVector,
    public readonly P1: PdfPoint,
    public readonly V1: PdfVector
  ) {}

  public calculatePoint(t: number): PdfPoint {
    const u = 1 - t;

    const p0PlusV0 = this.P0.move(this.V0);
    const p1PlusV1 = this.P1.move(this.V1);

    const u3 = u * u * u;
    const u2t3 = 3 * u * u * t;
    const ut23 = 3 * u * t * t;
    const t3 = t * t * t;

    const x = u3 * this.P0.x + u2t3 * p0PlusV0.x + ut23 * p1PlusV1.x + t3 * this.P1.x;

    const y = u3 * this.P0.y + u2t3 * p0PlusV0.y + ut23 * p1PlusV1.y + t3 * this.P1.y;

    return new PdfPoint(x, y);
  }
}

PageGen.prototype.drawBezierCurve = function (pen: PdfPen, curve: BezierCurve): void {
  if (!curve || curve.segments.length === 0) return;

  const points: PdfPoint[] = [];

  points.push(curve.segments[0].P0);

  for (const segment of curve.segments) {
    points.push(segment.P0.move(segment.V0));
    points.push(segment.P1.move(segment.V1));
    points.push(segment.P1);
  }

  this.drawBeziers(pen, null, points);
};
